import type { UseSessionReturn } from '../hooks/sessionTypes';
import type { Area } from '../utils/scope';

export type StreamWorkspaceTab = 'story' | 'sequence' | 'process' | 'vsm' | 'pain';

export interface StreamWorkspaceStream extends Area {
  mappingSessionId?: string;
  vsmBaseline?: unknown;
  sequenceOverlay?: unknown;
  painLinks?: unknown[];
  sharedProcesses?: { version: number; processIds: string[]; measurements?: Record<string, unknown>; commands?: unknown[] };
}

export interface StreamWorkspacePanelProps {
  stream: StreamWorkspaceStream;
  session: UseSessionReturn;
  readOnly?: boolean;
}

export interface StreamWorkspaceReadPanelProps {
  stream: StreamWorkspaceStream;
  session?: Pick<UseSessionReturn, 'sessionId' | 'newModel' | 'spine'> & Partial<Pick<UseSessionReturn, 'conversationHistory' | 'sessionLoading' | 'callStatus'>>;
  readOnly?: boolean;
}

export const EMPTY_STREAM_READ_SESSION: NonNullable<StreamWorkspaceReadPanelProps['session']> = {
  sessionId: null, spine: [],
  newModel: { flowText: '', openQuestions: '', nextQuestion: '', raw: '', frozenBoundary: 0 },
};
